import { SafetyDriverGuidanceAreaRoutes } from '@backoffice-frontend/common'
import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { SteeringWheelIcon } from '@moia-dev/pace-icons'

export const SafetyDriverGuidanceAreaNavigationIcon = SteeringWheelIcon

export const SafetyDriverGuidanceAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={SafetyDriverGuidanceAreaRoutes.route}
      Icon={SteeringWheelIcon}
    />
  )
}
